import React, {RefObject} from 'react';

import {IMonitoringResultLog, IProgramSetProgram} from 'store/slices/documents-uploading-slice';

import {DocumentsUploadLog} from './documents-upload-log';

export interface IDocumentsUploadLogContainerProps {
    ref?: RefObject<HTMLDivElement>;
    logs?: { programId: number; log?: IMonitoringResultLog }[];
    programSetPrograms: IProgramSetProgram[];
}

export const DocumentsUploadLogs = ({logs, programSetPrograms, ref}: IDocumentsUploadLogContainerProps) => (
    <div
        ref={ref}
        onClick={e => e.stopPropagation()}
        className="monitoring-logs"
    >
        {logs?.map(programLog => {
            const program = programSetPrograms
                .find(programSet => programSet?.program?.id === programLog.programId);
            return program && programLog.log && (
                <DocumentsUploadLog
                    log={programLog.log}
                    program={program.program}
                />
            );
        })}
    </div>
);
